import React, { useEffect, useRef, useState } from "react";
import { Avatar, Box, Grid, List, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText, Paper } from '@mui/material';
import { getAllSites, getEmails } from "../../../selectors/AdminSelectors";
import { observer } from "mobx-react-lite";
import { withRouter } from "react-router-dom";
import { StyledMultilineTextField, StyledRichTextEditor, StyledTextField } from "../../common/StyledTextField";
import { AddCardRounded, AddCircleOutline, ArrowBackIos, ArrowForwardIos, EmailOutlined, Settings, StorefrontOutlined } from "@mui/icons-material";
import { LoadingButton, TextButton, TooltipIconButton } from "../../common/StyledButtons";
import Colors from "../../../constants/Colors";
import StyledSubHeader from "../../common/StyledSubHeader";
import { isAdmin } from "../../../actions/profile/UserActions";
import { getAllUsersForAdmin, getEmailsForAdmin, sendEmailBlastForAdmin } from "../../../actions/internal/AdminActions";
import { getUserId } from "../../../selectors/UserSelectors";
import { NOTIFICATION_TYPE, showNotificationBar } from "../../../actions/error-pages/NotificationBarActions";
import StyledProgressCircle, { StyledLoadingSection } from "../../common/StyledProgressCircle";
import { getAllUsers } from "../../../clients/bettercallkyle/BckApi";
import StyledAvatarChipsTextField from "../../common/StyledAvatarChipTextField";
import StyledPage from "../../common/StyledPage";
import StyledSwitch from "../../common/StyledSwitch";
import StyledSection from "../../common/StyledSection";
import { formatDateTimeToFancyString } from "../../../utilities/DateUtilities";

const AdminEmailMarketingPage = ({ history }) => {
    
    const [isLoading, setIsLoading] = useState(true);
    
    const emails = getEmails();

    const loadData = async () => {
        if (!isAdmin()) {
            history.replace('/dashboard');
            return;
        }
        try {
            const userId = getUserId();
            await getEmailsForAdmin(userId, ['DRAFT', 'SCHEDULED', 'SENT']);
        } catch(err) {
            const e = await err;
            console.error(e);
            showNotificationBar(NOTIFICATION_TYPE.ERROR, 'Uh oh! There was a problem retrieving site information.')
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        loadData();
    }, []);

    const loadingContent = (
        <StyledLoadingSection />
    )

    if (isLoading) return (loadingContent)

    const renderCreateNewEmailButton = () => (
        <TextButton
          onClick={() => history.push(`/admin/email-marketing/create`)}
          sx={{ display: 'flex', alignItems: 'center', padding: '4px' }}
        >
          <AddCircleOutline fontSize="small" sx={{ marginRight: '4px' }} />
          Create New Email
        </TextButton>
    );

    const renderEmailSection = () => (
        <StyledSection
            title={'Emails'}
            rightAdornment={renderCreateNewEmailButton()}
        >
            {isLoading ? 
                <StyledProgressCircle />
                :
                <Paper variant='outlined' sx={{ marginTop: '5px', paddingLeft: '10px', paddingRight: '10px' }}>
                    <List style={{ flex: 1 }}>
                        {emails && emails.map((email, index) => (
                            <ListItem
                            dense
                            key={email.email_id}
                            sx={{
                                backgroundColor: '#fff',
                                marginBottom: '5px',
                                paddingRight: '55px',
                                borderBottom: index !== emails.length - 1 ? '1px solid #e0e0e0' : 'none',
                            }}
                            >

                            <ListItemText
                                primary={email.email_content.subject || 'No Title'}
                                secondary={`Created on ${formatDateTimeToFancyString(email.metadata.created_timestamp)}`}
                            />

                            <ListItemSecondaryAction sx={{ marginLeft: "10px" }}>
                                <TooltipIconButton
                                text="View Email"
                                icon={
                                    <EmailOutlined
                                        sx={{ color: Colors.primaryColor }}
                                        onClick={() => history.push(`/admin/email-marketing/${email.email_id}`)}
                                    />
                                }
                                />
                            </ListItemSecondaryAction>
                            
                            </ListItem>
                        ))}
                        
                        {(!emails || emails.length === 0) && <p>No emails created yet.</p>}
                    </List>
                </Paper>
            }
        </StyledSection>
    )

    // Implement Search and Pagination next
    return (
        <StyledPage>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <StyledSubHeader title="Email Marketing (Beta)" />
                </Grid>

                <Grid item xs={12}>
                    {renderEmailSection()}
                </Grid>
            </Grid>
        </StyledPage>
    )
}

export default withRouter(observer(AdminEmailMarketingPage));

